export type SignupStyles = {
  template: string;
  buttonBgColor: string;
  buttonTextColor: string;
  placeholderBgColor?: string;
  placeholderTextColor?: string;
  buttonFontFamily: string;
  fontFamily: string;
  buttonText: string;
  placeholderText: string;
  borderEnabled: boolean;
  borderColor: string;
  emailIconEnabled: boolean;
  bodyTextColor?: string;
  fontSize?: 'sm' | 'lg';
};

export enum SubscriberGate {
  POPUP = 'popup',
  GATED = 'gated',
  FORM = 'form',
  NONE = 'none',
}

export interface TemplateProps {
  signupStyles: SignupStyles;
  isSubmitting: boolean;
  autoFocus: boolean;
  email: string;
  setEmail: (email: string) => void;
  onEmailChange?: (email: string) => void;
}

export interface SignupProps {
  signupStyles: SignupStyles;
  type?: SubscriberGate;
  onEmailChange?: (email: string) => void;
  onSuccess?: () => void;
  autoFocus?: boolean;
  premiumOfferId?: string;
}
